// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class LiveFeedCacheService {
  private cacheKey = '';
  private ttlMs = 60 * 60 * 1000; // 1 hour

  constructor(private apiService: ApiService, private tenantService: TenantService) {
    // Use tenantId if available, fallback to tenantKey if tenantId is empty
    const tenantIdentifier = this.tenantService.getTenantId() || this.tenantService.getTenantKey();
    this.cacheKey = `liveFeedJson_${tenantIdentifier}`;
  }

  getLiveFeedUrl(): Observable<any[]> {
    const cached = sessionStorage.getItem(this.cacheKey);

    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        const now = new Date();

        if (new Date(parsed.expiresAt) > now) {
          return of(parsed.data);
        } else {
          sessionStorage.removeItem(this.cacheKey);
        }
      } catch {
        sessionStorage.removeItem(this.cacheKey);
      }
    }

    return this.apiService.getData<any[]>('event/getLiveFeedUrl').pipe(
      tap(data => {
        sessionStorage.setItem(this.cacheKey, JSON.stringify({
          data,
          expiresAt: new Date(Date.now() + this.ttlMs).toISOString()
        }));
      })
    );
  }

  clearCache(): void {
    sessionStorage.removeItem(this.cacheKey);
  }
}
